/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";
import { formatDate, formatMoneyPunto } from "utils/formatters";
import { getPedidoPaymentInfo } from "utils/pedidoPayment";

const getRows = (data, handleOpenMenu) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      const formaPagoTexto = getPedidoPaymentInfo(item).etiqueta;
      rows.push({
        type: (
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
            data={
              item?.venta?.idAnulada ? (
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color: getUproColor("uproBlue"),
                  }}
                  fontSize="lg"
                >
                  assignment_late
                </Icon>
              ) : item?.venta && item?.estado === "CERRADO" && !item.cuentaCorriente ? ( // Mostrar tipoFactura solo si el estado es "CERRADO"
                <SoftButton
                  color={item?.venta?.CAE || item.cuentaCorriente ? "uproGreen" : "error"}
                  circular
                  iconOnly
                  size="small"
                >
                  {item?.venta?.CAE ? item?.venta?.tipoFactura : "!"}
                </SoftButton>
              ) : (
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color:
                      item?.estado === "ABIERTO"
                        ? getUproColor("uproPink")
                        : item?.estado === "CERRADO"
                        ? getUproColor("uproGreen")
                        : item?.estado === "PAGO EN REVISIÓN"
                        ? getUproColor("uproBlue")
                        : item?.estado === "RESERVADO" &&
                          item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                          item?.venta?.pagos[0]?.estado == "Pendiente"
                        ? getUproColor("error")
                        : item?.estado === "RESERVADO" &&
                          item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                          item?.venta?.pagos[0]?.estado == "Revision"
                        ? getUproColor("uproBlue")
                        : getUproColor("uproYellow"),
                  }}
                  fontSize="lg"
                >
                  {item?.estado === "ABIERTO"
                    ? "assignment"
                    : item?.estado === "CERRADO" && item?.cuentaCorriente
                    ? "account_balance_wallet"
                    : item?.estado === "CERRADO"
                    ? "assignment_turned_in"
                    : item?.estado === "PAGO EN REVISIÓN"
                    ? "error_outline"
                    : item?.estado === "RESERVADO" &&
                      item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                      item?.venta?.pagos[0]?.estado == "Pendiente"
                    ? "notification_important"
                    : item?.estado === "RESERVADO" &&
                      item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                      item?.venta?.pagos[0]?.estado == "Revision"
                    ? "hourglass_empty"
                    : "receipt"}
                </Icon>
              )
            }
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftBox pl={3} mr={2}>
              <Tooltip
                title={
                  item?.venta?.idAnulada
                    ? `Factura ${item.venta.tipoFactura} (Anulada)`
                    : item?.venta?.tipoFactura &&
                      item?.venta?.CAE != null &&
                      item?.estado === "CERRADO"
                    ? `Factura ${item.venta.tipoFactura}`
                    : item?.venta?.tipoFactura &&
                      item?.venta?.CAE == null &&
                      item?.estado === "CERRADO" &&
                      !item.cuentaCorriente
                    ? `Factura pendiente`
                    : item.cuentaCorriente && item?.estado === "CERRADO"
                    ? "Cuenta corriente"
                    : `${makeNiceText(item?.estado)}`
                }
                placement="top"
              >
                {item?.venta?.idAnulada ? (
                  <Icon
                    sx={{
                      verticalAlign: "middle",
                      cursor: "pointer",
                      color: getUproColor("uproBlue"),
                    }}
                    fontSize="lg"
                  >
                    assignment_late
                  </Icon>
                ) : item?.venta && item?.estado === "CERRADO" && !item.cuentaCorriente ? ( // Mostrar tipoFactura solo si el estado es "CERRADO"
                  <SoftButton
                    color={item?.venta?.CAE || item.cuentaCorriente ? "uproGreen" : "error"}
                    circular
                    iconOnly
                    size="small"
                  >
                    {item?.venta?.CAE ? item?.venta?.tipoFactura : "!"}
                  </SoftButton>
                ) : (
                  <Icon
                    sx={{
                      verticalAlign: "middle",
                      cursor: "pointer",
                      color:
                        item?.estado === "ABIERTO"
                          ? getUproColor("uproPink")
                          : item?.estado === "CERRADO"
                          ? getUproColor("uproGreen")
                          : item?.estado === "PAGO EN REVISIÓN"
                          ? getUproColor("uproBlue")
                          : item?.estado === "RESERVADO" &&
                            item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                            item?.venta?.pagos[0]?.estado == "Pendiente"
                          ? getUproColor("error")
                          : item?.estado === "RESERVADO" &&
                            item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                            item?.venta?.pagos[0]?.estado == "Revision"
                          ? getUproColor("uproBlue")
                          : getUproColor("uproYellow"),
                    }}
                    fontSize="lg"
                  >
                    {item?.estado === "ABIERTO"
                      ? "assignment"
                      : item?.estado === "CERRADO" && item?.cuentaCorriente
                      ? "account_balance_wallet"
                      : item?.estado === "CERRADO"
                      ? "assignment_turned_in"
                      : item?.estado === "PAGO EN REVISIÓN"
                      ? "error_outline"
                      : item?.estado === "RESERVADO" &&
                        item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                        item?.venta?.pagos[0]?.estado == "Pendiente"
                      ? "notification_important"
                      : item?.estado === "RESERVADO" &&
                        item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                        item?.venta?.pagos[0]?.estado == "Revision"
                      ? "hourglass_empty"
                      : "receipt"}
                  </Icon>
                )}
              </Tooltip>
            </SoftBox>
          </SoftBox>
        ),
        id: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={item?.id}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        numeroComanda: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={item?.detalles
              .map((detalle) => detalle.numeroComanda)
              .filter((value, index, self) => self.indexOf(value) === index)
              .join(", ")}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.detalles
                .map((detalle) => detalle.numeroComanda)
                .filter((value, index, self) => self.indexOf(value) === index)
                .join(", ")}
            </SoftTypography>
          </SoftBox>
        ),
        cliente: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={
              item?.cliente
                ? makeNiceText(`${item.cliente.nombre} ${item.cliente.apellido}`, "nombre")
                : "Particular"
            }
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.cliente
                ? makeNiceText(`${item.cliente.nombre} ${item.cliente.apellido}`, "nombre")
                : "Particular"}
            </SoftTypography>
            {item.bandejas && !item.bandejasDevueltas && (
              <Tooltip
                title={`Adeuda ${item.bandejas} bandeja${item.bandejas > 1 ? "s" : ""}`}
                placement="top"
              >
                <Icon
                  sx={{
                    color: getUproColor("uproPink"),
                    cursor: "pointer",
                    ml: 0.5,
                  }}
                >
                  local_dining
                </Icon>
              </Tooltip>
            )}
            {item.paraRetirar && (
              <Tooltip title="Para retirar" placement="top">
                <Icon
                  sx={{
                    color: getUproColor("uproGreen"),
                    cursor: "pointer",
                    ml: 0.5,
                  }}
                >
                  local_shipping
                </Icon>
              </Tooltip>
            )}
          </SoftBox>
        ),
        app: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={item?.cliente ? item?.cliente?.appUsuario : "Particular"}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.cliente
                ? item?.cliente?.appUsuario == "Compras"
                  ? "Gestion Upro"
                  : item?.cliente?.appUsuario
                : "Particular"}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={
              item?.venta?.idAnulada
                ? `Factura ${item.venta.tipoFactura} (Anulada)`
                : item?.venta?.tipoFactura && item?.estado !== "RESERVADO"
                ? `Factura ${item.venta.tipoFactura}`
                : `${makeNiceText(item?.estado)}`
            }
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              <SoftBadge
                variant="color"
                color={
                  item?.estado === "ABIERTO"
                    ? getUproColor("primary")
                    : item?.estado === "CERRADO" && item?.cierreAutomatico
                    ? getUproColor("error")
                    : item?.estado === "CERRADO"
                    ? getUproColor("uproGreen")
                    : item?.estado === "ANULADO" || item?.estado === "PAGO EN REVISIÓN"
                    ? getUproColor("uproBlue")
                    : item?.estado === "RESERVADO" &&
                      item?.venta?.pagos[0]?.medioDePago?.nombre != "Transferencia"
                    ? getUproColor("uproYellow")
                    : item?.estado === "RESERVADO" &&
                      item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                      item?.venta?.pagos[0]?.estado == "Pendiente"
                    ? getUproColor("error")
                    : item?.estado === "RESERVADO" &&
                      item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                      item?.venta?.pagos[0]?.estado == "Revision"
                    ? getUproColor("uproBlue")
                    : getUproColor("uproYellow")
                }
                badgeContent={
                  item?.estado === "RESERVADO" &&
                  dayjs(item?.fechaPedido).isBefore(dayjs().startOf("day"))
                    ? "Reserva vencida"
                    : item?.estado === "RESERVADO" &&
                      item?.venta?.pagos[0]?.medioDePago?.nombre != "Transferencia"
                    ? `Reservado para ${
                        dayjs(item?.fechaPedido).isAfter(dayjs().subtract(2, "day"))
                          ? formatDate(item?.fechaPedido, "XXXX")
                          : formatDate(item?.fechaPedido, "dd/MM/yyyy")
                      }`
                    : item?.estado === "RESERVADO" &&
                      item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                      item?.venta?.pagos[0]?.estado == "Pendiente"
                    ? `Pendiente de pago`
                    : item?.estado === "RESERVADO" &&
                      item?.venta?.pagos[0]?.medioDePago?.nombre == "Transferencia" &&
                      item?.venta?.pagos[0]?.estado == "Revision"
                    ? `Pago en revisión`
                    : item?.estado === "CERRADO" && item?.cierreAutomatico
                    ? "Cerrado Automático"
                    : item?.estado
                }
              />
            </SoftTypography>
          </SoftBox>
        ),
        formaPago: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={formaPagoTexto}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {formaPagoTexto}
            </SoftTypography>
          </SoftBox>
        ),
        mozo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={item?.mozo ? item?.mozo?.nombre + " " + item?.mozo?.apellido : ""}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.mozo ? item?.mozo?.nombre + " " + item?.mozo?.apellido : ""}
            </SoftTypography>
          </SoftBox>
        ),
        total: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={
              item?.total
                ? `$ ${formatMoneyPunto(item?.total)}`
                : `
            $ ${formatMoneyPunto(
              item?.detalles.reduce((acc, detalle) => acc + detalle.cantidad * detalle.precio, 0)
            )}
            `
            }
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.total
                ? `$ ${formatMoneyPunto(item?.total)}`
                : `
              $ ${formatMoneyPunto(
                item?.detalles.reduce((acc, detalle) => acc + detalle.cantidad * detalle.precio, 0)
              )}
              `}
            </SoftTypography>
            <Tooltip title={item?.total ? "Pagado" : "Pendiente de pago"} placement="top">
              <Icon
                sx={{
                  color: item?.total ? getUproColor("uproGreen") : getUproColor("uproYellow"),
                  cursor: "pointer",
                  ml: 0.5,
                }}
              >
                {item?.total ? "done" : "hourglass_empty"}
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
        creado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={
              dayjs(item?.createdAt).isAfter(dayjs().subtract(2, "day"))
                ? formatDate(item?.createdAt, "XXXX a las hh:mm")
                : formatDate(item?.createdAt, "dd/MM/yyyy a las hh:mm")
            }
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {dayjs(item?.createdAt).isAfter(dayjs().subtract(2, "day"))
                ? formatDate(item?.createdAt, "XXXX a las hh:mm")
                : formatDate(item?.createdAt, "dd/MM/yyyy a las hh:mm")}
            </SoftTypography>
          </SoftBox>
        ),
        actualizado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={
              dayjs(item?.updatedAt).isAfter(dayjs().subtract(2, "day"))
                ? formatDate(item?.updatedAt, "XXXX a las hh:mm")
                : formatDate(item?.updatedAt, "dd/MM/yyyy a las hh:mm")
            }
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {dayjs(item?.updatedAt).isAfter(dayjs().subtract(2, "day"))
                ? formatDate(item?.updatedAt, "XXXX a las hh:mm")
                : formatDate(item?.updatedAt, "dd/MM/yyyy a las hh:mm")}
            </SoftTypography>
          </SoftBox>
        ),
        comentario: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
            data={makeNiceText(item?.comentario) || ""}
          >
            <Tooltip title={makeNiceText(item?.comentario) || ""} placement="top">
              <SoftTypography
                verticalAlign="text-top"
                variant="caption"
                color="secondary"
                fontWeight="medium"
              >
                {item?.comentario?.length > 30
                  ? `${makeNiceText(item?.comentario).substring(0, 30)}...`
                  : makeNiceText(item?.comentario)}
              </SoftTypography>
            </Tooltip>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getUproColor("uproGreen"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "ID", width: "1%", align: "left" },
  { name: "numeroComanda", desc: "Nº Comanda", width: "1%", align: "left" },
  { name: "cliente", desc: "Cliente", align: "left", noOrder: true },
  { name: "app", desc: "App", align: "left" },
  { name: "estado", desc: "Estado", align: "left" },
  { name: "formaPago", desc: "Forma de Pago", align: "left" },
  { name: "mozo", desc: "Mozo", align: "left" },
  { name: "total", desc: "Total", align: "left" },
  { name: "creado", desc: "Creado", align: "left", orderField: "createdAt" },
  { name: "actualizado", desc: "Actualizado", align: "left", orderField: "updatedAt" },
  { name: "comentario", desc: "Comentario", align: "left" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
